
export enum UNIT_AMOUNT {
    CUSTOM = -1
}

export enum AccountType {
    Group = 'group',
    Individual = 'individual'
}

/**
 * The Stripe Price object as per the documentation
 *
 * @see https://docs.stripe.com/api/prices
 */
export interface StripePriceObject {
    /** The ID starts with "price_" */
    id: string,
    billing_scheme?: 'per_unit',
    currency: 'eur' | 'usd',
    recurring?: {
        interval: 'year',
        interval_count: number;
        trial_period_days: null | number;
    },
    unit_amount: number | UNIT_AMOUNT.CUSTOM,
    product: {
        name: string,
        description: string,
        metadata?: {
            accountType?: AccountType,
        }
    },
}

export const isCustom = (price: Pick<StripePriceObject, 'unit_amount'>) => price.unit_amount === UNIT_AMOUNT.CUSTOM;
export const isGroupProduct = (price: StripePriceObject) => price.product?.metadata?.accountType === AccountType.Group;
export const isIndividualProduct = (price: StripePriceObject) => price.product?.metadata?.accountType === AccountType.Individual;
